import type { TFunction } from "i18next";

export const brasilStates = [
  { label: "AC", value: "AC" },
  { label: "AL", value: "AL" },
  { label: "AP", value: "AP" },
  { label: "AM", value: "AM" },
  { label: "BA", value: "BA" },
  { label: "CE", value: "CE" },
  { label: "DF", value: "DF" },
  { label: "ES", value: "ES" },
  { label: "GO", value: "GO" },
  { label: "MA", value: "MA" },
  { label: "MS", value: "MS" },
  { label: "MT", value: "MT" },
  { label: "MG", value: "MG" },
  { label: "PA", value: "PA" },
  { label: "PB", value: "PB" },
  { label: "PR", value: "PR" },
  { label: "PE", value: "PE" },
  { label: "PI", value: "PI" },
  { label: "RJ", value: "RJ" },
  { label: "RN", value: "RN" },
  { label: "RS", value: "RS" },
  { label: "RO", value: "RO" },
  { label: "RR", value: "RR" },
  { label: "SC", value: "SC" },
  { label: "SP", value: "SP" },
  { label: "SE", value: "SE" },
  { label: "TO", value: "TO" },
];

export const getPaymentFrequencyOptions = (t: TFunction) => [
  { value: "monthly", label: t("common:paymentFrequency.monthly") },
  { value: "quarterly", label: t("common:paymentFrequency.quarterly") },
  { value: "semiannual", label: t("common:paymentFrequency.semiannual") },
  { value: "yearly", label: t("common:paymentFrequency.yearly") },
];

export const getTrialModeOptions = (t: TFunction) => [
  { value: "free", label: t("common:trialMode.free") },
  { value: "promotional", label: t("common:trialMode.promotional") },
];

const TRIAL_INTERVAL_DAYS: Record<string, number> = {
  weekly: 7,
  monthly: 30,
  quarterly: 90,
  semiannual: 180,
  yearly: 365,
};

/** Opções de duração do trial estritamente menores que o intervalo da oferta. */
export const getTrialIntervalOptions = (
  t: TFunction,
  recurringInterval?: string | null,
) => {
  const options = [
    { value: "weekly", label: t("common:trialInterval.weekly") },
    { value: "monthly", label: t("common:trialInterval.monthly") },
    { value: "quarterly", label: t("common:trialInterval.quarterly") },
  ];

  if (!recurringInterval) {
    return options;
  }

  const offerDays = TRIAL_INTERVAL_DAYS[recurringInterval] ?? 0;
  return options.filter(
    (option) => (TRIAL_INTERVAL_DAYS[option.value] ?? 0) < offerDays,
  );
};

export const getPaymentTypeOptions = (t: TFunction, canOfferRecurring = false) => [
  { value: 'single', label: t('common:paymentType.single') },
  ...(canOfferRecurring
    ? [{ value: 'recurring', label: t('common:paymentType.recurring') }]
    : []),
];

export const currencyOptions = [
  { value: "BRL", label: "BRL" },
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
];

export const getOfferCurrencyOptions = (_paymentType?: string) => currencyOptions;

export const formatCurrency = (value: number, currency: string) => {
  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
};

/** API monetary amounts are in cents; formatCurrency expects decimal units. */
export const formatCurrencyFromCents = (
  cents: number,
  currency: string,
) => formatCurrency(cents / 100, currency);

export const convertBytesToMB = (bytes: number) => {
  return (bytes / (1024 * 1024)).toFixed(2);
};

export const postalCodeMask = (country: string, value: string) => {
  const numericOnly = value?.replace(/\D/g, "");

  switch (country.toLowerCase()) {
    case "brasil":
      return numericOnly?.replace(/(\d{5})(\d{3})/, "$1-$2").substring(0, 9);
    default:
      return value;
  }
};

export const dateMask = (value: string): string => {
  const cleaned = value.replace(/\D/g, '').slice(0, 8);
  const day = cleaned.slice(0, 2);
  const month = cleaned.slice(2, 4);
  const year = cleaned.slice(4, 8);

  let masked = '';
  if (day) masked += day;
  if (month) masked += `/${month}`;
  if (year) masked += `/${year}`;

  return masked;
};
